import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect, useState } from 'react'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomMultiSelect,
  CustomPanel,
  DateTime,
  PageHeader,
  Periodo,
  ThreeDots,
} from '../../../../components'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Fieldset } from 'primereact/fieldset'

import useGestaoMdfes, { LOAD_MESSAGE } from './GestaoMdfesHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import ModalCancelarMdfe from './ModalCancelarMdfe'
import ModalEncerrarMdfe from './ModalEncerrarMdfe'
import BadgeStatusCte from '../../../../components/BadgeStatusCte/BadgeStatusCte'
import ModalAcaoCiot from '../Ciot/ModalAcaoCiot'
import { parseCiotsVinculados } from '../Ciot/ciot.util'

const MENU_ENCERRAR_CIOT = 'Encerrar CIOT'
const MENU_CANCELAR_CIOT = 'Cancelar CIOT'

const itensMenuCiot = mdfe => {
  const declarados = parseCiotsVinculados(mdfe.ciots_vinculados).filter(
    ciot => ciot.status === 'declarado',
  )
  return declarados.map(ciot => {
    const sufixo = declarados.length > 1 ? ` ${ciot.numero}` : ''
    return {
      ciot,
      itens: [`${MENU_ENCERRAR_CIOT}${sufixo}`, `${MENU_CANCELAR_CIOT}${sufixo}`],
    }
  })
}

function GestaoMdfes({ dispatch, selectedTp, history }) {
  const { state, localDispatch } = useGestaoMdfes()
  const [globalFilter, setGlobalFilter] = useState('')
  const [modalCiot, setModalCiot] = useState({ visible: false, acao: null, ciot: null })

  const onMenuClick = (item, mdfe) => {
    const alvo = itensMenuCiot(mdfe).find(({ itens }) => itens.includes(item))
    if (!alvo) {
      localDispatch.onMenuItemClick(item, mdfe)
      return
    }
    const acao = item.startsWith(MENU_CANCELAR_CIOT) ? 'cancelar' : 'encerrar'
    setModalCiot({ visible: true, acao, ciot: alvo.ciot })
  }

  // Events
  useEffect(() => {
    localDispatch.onInit(selectedTp, state.periodo.dataInicial, state.periodo.dataFinal)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.FETCH:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      case LOAD_MESSAGE.DELETE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.deleteMdfe(state.selectedMdfe)
        break

      case LOAD_MESSAGE.SUCCESS_DELETE:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        localDispatch.resetState()
        localDispatch.onInit(selectedTp, state.periodo.dataInicial, state.periodo.dataFinal)
        break

      case LOAD_MESSAGE.ENCERRAR:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.encerrarMdfe(state.selectedMdfe)
        break

      case LOAD_MESSAGE.SUCCESS_ENCERRAR_MDFE:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        localDispatch.resetState()
        localDispatch.onInit(selectedTp, state.periodo.dataInicial, state.periodo.dataFinal)
        break

      case LOAD_MESSAGE.SYNC:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.syncMdfe(state.selectedMdfe)
        break

      case LOAD_MESSAGE.SUCCESS_SYNC:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        localDispatch.resetState()
        localDispatch.onInit(selectedTp, state.periodo.dataInicial, state.periodo.dataFinal)
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  // Helpers

  // Render
  return (
    <>
      <PageHeader>3.19 - Gestão de MDFe's</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-3">
              <Periodo
                periodoFinal={state.periodo.dataFinal}
                periodoInicial={state.periodo.dataInicial}
                onPesquisar={(pInicial, pFinal) =>
                  localDispatch.onPesquisar(selectedTp, pInicial, pFinal)
                }
              />
            </div>
            <div
              style={{
                display: 'flex',
                marginLeft: '5px',
                gap: '10px',
                paddingTop: 35,
              }}
            >
              <div>
                <Btn
                  onClick={() =>
                    localDispatch.onDownloadMdfe(state.filteredMdfes.filter(m => m.selected))
                  }
                >
                  Download MDFe
                </Btn>
              </div>
              <div>
                <a href="https://status.focusnfe.com.br/" target="_blank" rel="noopener noreferrer">
                  <Btn>Consultar Status Emissão MDFe</Btn>
                </a>
              </div>
              <div>
                <Btn onClick={() => history.push('/main/entregas/gestao-ciots')}>
                  Gestão de CIOT
                </Btn>
              </div>
            </div>

            <Fieldset legend="Filtro" toggleable collapsed={true} className="p-col-12 p-mt-2">
              <div className="p-grid">
                <div className="p-col-6 p-md-4">
                  <CustomMultiSelect
                    label="Status"
                    value={state.selectedStatus}
                    options={[
                      { label: 'Autorizado', value: 'autorizado' },
                      { label: 'Cancelado', value: 'cancelado' },
                      { label: 'Erro ao Autorizar', value: 'erro_autorizacao' },
                      { label: 'Processando', value: 'processando_autorizacao' },
                      { label: 'Denegado', value: 'denegado' },
                      { label: 'Encerrado', value: 'encerrado' },
                    ]}
                    onChange={value => localDispatch.handleStatusFiltroChange(value)}
                    optionLabel="label"
                  />
                </div>
              </div>
            </Fieldset>

            <div className="p-col-12" style={{ marginTop: 15, marginBottom: 10 }}>
              <CustomCheckbox
                checked={state.selecionarTodos}
                onChange={value => localDispatch.onSelecionarTodosChange(value)}
              >
                Selecionar Todos
              </CustomCheckbox>
            </div>

            <div className="p-col-12">
              <DataTable
                value={state.filteredMdfes}
                paginator={true}
                rows={10}
                emptyMessage="Não existem Mdfe's cadastradas"
                globalFilter={globalFilter}
                header={<CustomDataTableHeader onChange={setGlobalFilter} />}
              >
                <Column
                  header={'#'}
                  body={item => (
                    <CustomCheckbox
                      checked={item.selected}
                      onChange={() => localDispatch.onItemClicked(item)}
                    />
                  )}
                  style={tableCellCentered(60)}
                />
                <Column field="ref" header={'Referência'} style={tableCellCentered()} />
                <Column field="numero" header={'Número'} style={tableCellCentered(80)} />
                <Column field="serie" header={'Série'} style={tableCellCentered(60)} />
                <Column field="veiculo_placa" header={'Placa'} style={tableCellCentered(90)} />
                <Column
                  header={'Origem'}
                  style={tableCellCentered(70)}
                  body={item => (item.document_origin === 'nfe' ? 'NF-e' : 'CT-e')}
                />
                <Column field="ctes_numeros" header={'CTes'} style={tableCellCentered(100)} />
                <Column
                  header={'NFs'}
                  style={tableCellCentered(110)}
                  body={item =>
                    item.nfes_qtd ? (
                      <span title={item.nfes_identifiers}>
                        {item.nfes_qtd > 3 ? `${item.nfes_qtd} NFs` : item.nfes_identifiers}
                      </span>
                    ) : null
                  }
                />
                <Column field="ciots" header={'CIOT'} style={tableCellCentered(120)} />
                <Column field="emissor_razao_social" header={'Emitente'} />
                <Column
                  header={'Percurso'}
                  style={tableCellCentered(100)}
                  body={item => `${item.uf_inicio || ''} → ${item.uf_fim || ''}`}
                />
                <Column
                  field="status"
                  header={'Status'}
                  body={item => (
                    <BadgeStatusCte status={item.status} description={item.mensagem_sefaz} />
                  )}
                />
                <Column
                  field="updated_at"
                  header={'Data'}
                  style={tableCellCentered(150)}
                  body={item => <DateTime>{item.updated_at}</DateTime>}
                />
                <Column
                  header="Menu"
                  style={tableCellCentered(70)}
                  body={mdfe => {
                    const menuItems = []
                    if (mdfe.caminho_damdfe) menuItems.push('DAMDFE')
                    if (mdfe.caminho_xml) menuItems.push('XML')
                    if (mdfe.caminho_xml_cancelamento) menuItems.push('XML Cancelamento')
                    if (mdfe.caminho_xml_encerramento) menuItems.push('XML Encerramento')
                    if (mdfe.status === 'autorizado') menuItems.push('Encerrar')
                    if (['autorizado', 'processando_autorizacao'].includes(mdfe.status))
                      menuItems.push('Sincronizar Status')
                    if (mdfe.status === 'autorizado') menuItems.push('Cancelar MDFe')
                    itensMenuCiot(mdfe).forEach(({ itens }) => menuItems.push(...itens))

                    return menuItems.length > 0 ? (
                      <ThreeDots items={menuItems} onClick={item => onMenuClick(item, mdfe)} />
                    ) : null
                  }}
                  bodyStyle={tableCellCentered()}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalCancelarMdfe
        isVisible={state.modal.visible}
        mdfe={state.modal.mdfe}
        onCancel={localDispatch.onModalDeleteClose}
        onSave={localDispatch.onModalDeleteSave}
        onError={localDispatch.onModalError}
      />
      <ModalEncerrarMdfe
        isVisible={state.modalEncerrar.visible}
        mdfe={state.modalEncerrar.mdfe}
        onCancel={localDispatch.onModalEncerrarClose}
        onSave={localDispatch.onModalEncerrarSave}
        onError={localDispatch.onModalError}
      />
      <ModalAcaoCiot
        visible={modalCiot.visible}
        acao={modalCiot.acao}
        ciot={modalCiot.ciot}
        onClose={() => setModalCiot({ visible: false, acao: null, ciot: null })}
        onConcluido={(_, mensagem) => {
          setModalCiot({ visible: false, acao: null, ciot: null })
          dispatch(showMessageBox(mensagem, null))
          localDispatch.onPesquisar(selectedTp, state.periodo.dataInicial, state.periodo.dataFinal)
        }}
        onError={localDispatch.onModalError}
      />
    </>
  )
}
const mapToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapToProps)(withRouter(GestaoMdfes))
